// Note: Constants for react-query in milliseconds
export const staleTime1Day = 1000 * 60 * 60 * 24;
export const staleTime5Min = 1000 * 60 * 5;
export const staleTime6Days = 1000 * 60 * 60 * 24 * 6;
export const staleTime1Min = 1000 * 60;
export const staleTime30sec = 1000 * 30;
